<script lang="ts">
    import {
        windowHeight as windowHeightStore,
        windowWidth as windowWidthStore,
    } from "./store";

    let windowWidth: number;
    let windowHeight: number;

    $: windowHeightStore.set(windowHeight);
    $: windowWidthStore.set(windowWidth);
</script>

<svelte:window bind:innerWidth={windowWidth} bind:innerHeight={windowHeight} />
